var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfographic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41026 22.1601H19.0033C20.1815 22.1601 21.1708 21.3147 21.3776 20.1905H6.17855C3.85821 20.1905 1.96959 18.3018 1.96959 15.9815V3.80426C0.845394 4.0201 0 5.00042 0 6.17857V19.7588C0 21.0809 1.07923 22.1601 2.41026 22.1601Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9436 12.3302L17.3757 9.19148L11.9436 6.05273V12.3302Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7717 0H6.17857C4.84755 0 3.76831 1.07923 3.76831 2.40126V15.9815C3.76831 17.3126 4.84755 18.3918 6.17857 18.3918H22.7717C24.1027 18.3918 25.1819 17.3126 25.1819 15.9815V2.40126C25.1819 1.07923 24.1027 0 22.7717 0ZM18.4907 10.6304L12.6269 14.0119C12.3661 14.1648 12.0783 14.2368 11.7995 14.2368C11.5117 14.2368 11.2329 14.1648 10.9721 14.0119C10.4505 13.7151 10.1447 13.1845 10.1447 12.5819V5.80084C10.1447 5.20724 10.4505 4.66765 10.9721 4.37084C11.4848 4.07404 12.1053 4.07404 12.6269 4.37084L18.4907 7.76142C19.0124 8.05823 19.3181 8.59782 19.3181 9.19136C19.3181 9.79397 19.0124 10.3246 18.4907 10.6304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfographic);
export default __webpack_public_path__ + "static/media/Infographic.49e18cf1441e1e4cadcaa34c77722d38.svg";
export { ForwardRef as ReactComponent };